import { type SimpleCommentProps } from '@common/types/SimpleCommentProps';
import { Avatar } from '@web/atoms/Avatar';
import styles from '@web/molecules/SimpleComment/SimpleComment.module.scss';

import { CommentCard } from './atoms/CommentCard';
import { CommentMeta } from './atoms/CommentMeta';

const COMMENT_ANCHOR_PREFIX = 'comment_';

export const SimpleComment = ({
    id,
    user,
    likeCount,
    metaSuffix,
    metaIcon,
    reactionTxt,
    link,
}: SimpleCommentProps) =>
    user && reactionTxt ? (
        <li className={styles.SimpleComment}>
            <a href={`${link}#${COMMENT_ANCHOR_PREFIX}${id}`}>
                <Avatar className={styles.avatar} src={user.image} isRounded />
                <CommentCard
                    userName={user?.userName}
                    userLikeCount={user?.likeCount}
                    reactionTxt={reactionTxt}
                    role={user?.role}
                />
                {metaSuffix ? (
                    <CommentMeta metaIcon={metaIcon} metaSuffix={metaSuffix} count={likeCount || 0} />
                ) : null}
            </a>
        </li>
    ) : null;
